import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import user from 'js/lib/user';

import { Button } from '@coursera/cds-core';
import { ThumbsUpIcon } from '@coursera/cds-icons';

import { cancelUpvote, upvote } from 'bundles/discussions/actions/ThreadDetailsActions';

import _t from 'i18n!nls/discussions';

class Like extends React.Component {
  static propTypes = {
    post: PropTypes.object,
    ariaDescribedBy: PropTypes.string,
    isReadOnlyAfterSessionEnd: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof Like.contextTypes>;

  state = {
    clickedUpvote: false,
  };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    this.setState({ clickedUpvote: this.props.post.isUpvoted });
  }

  toggleUpvote = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { post } = this.props;
    const { clickedUpvote } = this.state;

    if (clickedUpvote === post.isUpvoted) {
      if (post.isUpvoted) {
        this.context.executeAction(cancelUpvote, { post });
        this.setState({ clickedUpvote: false });
      } else {
        this.context.executeAction(upvote, { post });
        this.setState({ clickedUpvote: true });
      }
    }
  };

  formatVoteCount(c: $TSFixMe) {
    let count = c || 0;
    if (count.toString().length > 3) {
      count = Math.round((count / 1000) * 10) / 10;
      count += 'k';
    }
    return count;
  }

  render() {
    const userId = user.get().id;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (!this.props.post) return null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { post, ariaDescribedBy, isReadOnlyAfterSessionEnd } = this.props;
    const postedByCurrentUser = post.creator?.userId === userId;
    const upvoteCount = post.upvotes === undefined ? post.upvoteCount : post.upvotes;
    const voteCount = this.formatVoteCount(upvoteCount);
    const hasError = post.upvoteError;

    const message =
      voteCount === 0
        ? _t('Like')
        : _t(`Like (#{voteCount})`, {
            voteCount,
          });

    return (
      <Button
        onClick={this.toggleUpvote}
        aria-label={message}
        aria-pressed={post.isUpvoted}
        aria-describedby={ariaDescribedBy}
        variant="ghost"
        icon={<ThumbsUpIcon size="small" />}
        iconPosition="before"
        size="small"
        edgeAlign="start"
        disabled={hasError || postedByCurrentUser || isReadOnlyAfterSessionEnd}
      >
        {hasError ? _t('Sorry, something went wrong') : message}
      </Button>
    );
  }
}

export default Like;
